import Vue from 'vue';
import Router from 'vue-router';
import AppPage from '@/components/layout/AppPage.vue';
import MaintenancePage from '@/components/layout/MaintenancePage.vue';
import UserActionsPage from '@/components/pages/user/UserActionsPage.vue';
import { MAINTENANCE_MODE } from '@/config';
import { Features, isEnabled } from '@/config/features';
import { updateTitle } from '@/helpers/page';
import { ns } from '@/helpers/store';
import store from '@/store';
import { ACCOUNT_KEY } from '@/store/modules/role';
import { FETCH_USER, LOGOUT } from '@/store/types/actions';
import { AUTH } from '@/store/types/namespaces';
import CohortRoutes from './routes/Cohort';
import ConnectRoutes from './routes/Connect';
import DashboardRoutes from './routes/Dashboard';
import IncidentRoutes from './routes/Incidents';
import MonitorRoutes from './routes/Monitor';
import SettingsRoutes from './routes/Settings';
import UserRoutes from './routes/User';
import ViewRoutes from './routes/View';
Vue.use(Router);
// TODO: provide better titling.
const routes = [
    // aspects:
    {
        path: '/',
        name: 'page',
        component: AppPage,
        redirect: '/dashboard',
        children: [].concat(CohortRoutes, DashboardRoutes, ViewRoutes, IncidentRoutes, MonitorRoutes, ConnectRoutes, SettingsRoutes),
    },
    {
        path: '/user',
        name: 'user',
        component: UserActionsPage,
        children: UserRoutes,
        redirect: '/user/login',
    },
    {
        path: '/maintenance',
        name: 'maintenance',
        meta: { public: true, title: 'Under maintenance' },
        component: MaintenancePage,
    },
    // defaults:
    { path: '/connect', redirect: '/connect/get-started' },
    { path: '/login', redirect: '/user/login' },
    { path: '/settings', redirect: '/settings/my-user' },
    { path: '/learn', redirect: '/learn/tutorial' },
    // aliases:
    { path: '/register', redirect: '/user/register' },
    { path: '/reset', redirect: '/user/reset' },
    // moved pages:
    { path: '/connect/properties', redirect: '/settings/properties' },
    { path: '/connect/delete', redirect: '/settings/delete' },
    { path: '/monitor/events', redirect: '/monitor' },
    { path: '/monitor/configuration', redirect: '/monitor' },
    { path: '/monitor/configuration/create', redirect: '/monitor/create' },
    { path: '/monitor/configuration/edit/:id', redirect: '/monitor/edit/:id' },
    { path: '/monitor/actions', redirect: '/monitor' },
];
routes.push(
// catch-all:
{ path: '*', redirect: '/dashboard' });
const router = new Router({
    routes,
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
});
router.beforeEach(async (to, _, next) => {
    if (MAINTENANCE_MODE
        && !isEnabled(Features.OVERRIDE_MAINTENANCE_MODE)
        && to.name !== 'maintenance') {
        return next({ name: 'maintenance' });
    }
    // High scale mode
    if (isEnabled(Features.SCALE_MODE) && !to.meta?.highScale) {
        return next({ name: 'incidents' });
    }
    if (!MAINTENANCE_MODE
        && !isEnabled(Features.OVERRIDE_MAINTENANCE_MODE)
        && to.name === 'maintenance') {
        return next({ name: 'dashboard' });
    }
    if (to.meta?.public) {
        return next();
    }
    try {
        await store.dispatch(ns(AUTH, FETCH_USER));
        const accountId = window.localStorage.getItem(ACCOUNT_KEY);
        if (!accountId && to.name !== 'accounts') {
            return next({ name: 'accounts' });
        }
        return next();
    }
    catch (error) {
        if (error && error.forceSignOut) {
            await store.dispatch(ns(AUTH, LOGOUT));
        }
        return next({ name: 'login' });
    }
});
router.afterEach(updateTitle);
export default router;
